import { Constant, Headers } from "../apiConstants";

const GetDiningLocationAPI = async (location) => {
  const endpoint = Constant.GET_DINING_LOCATION + `?city=${location}`;
  const BaseUrl = Constant.BASE_URL;
  try {
    const response = await fetch(BaseUrl + "/" + endpoint, {
      method: "get",
      headers: Headers,
    });
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default GetDiningLocationAPI;
